export default {
  AvailableCompanies: 'باربری های محدود شده',
  PasswordChange: 'رمز عبور بروزرسانی شد',
  UserUpdate: 'کاربر بروزرسانی شد',
  NewUsersAdd: 'کاربر جدید اضافه شد',
  UserReamove: 'کاربر حذف شد',
  Activate: 'فعال',
  FatherName: 'نام پدر',
  BankCard: 'شماره کارت',
  BirthYear: 'سال تولد',
  BirthMonth: 'ماه تولد',
  BirthDay: 'روز تولد',
  ChangePassword: 'تغیر رمز عبور',
  Email: 'ایمیل',
  EmailConfirmed: 'تایید ایمیل',
  EconomicCode: 'کد اقتصادی',
  FirstName: 'نام',
  CompanyName: 'نام سازمان',
  UserName: 'نام کاربری',
  Mobile: 'موبایل',
  MobileConfimed: 'تایید موبایل',
  Name: 'نام',
  Specifications: 'مشخصات فنی',
  ScopeOfAccess: 'حوزه دسترسی',
  LastName: 'نام خانوادگی',
  LimitedUser: 'محدود بودن',
  Legal: 'شخص حقوقی',
  LegalNationalId: 'شناسه ملی',
  License: 'گواهی‌نامه',
  issueTime: 'تاریخ صدور گواهی‌نامه',
  licenseIssueTime: 'تاریخ صدور گواهی‌نامه',
  LicenseExpireTime: 'تاریخ اعتبار گواهی‌نامه',
  LicenseExpireTimeMin: 'اعتبار گواهی‌نامه از',
  LicenseExpireTimeMax: 'اعتبار گواهی‌نامه تا',
  LicenseImage: 'عکس گواهی‌نامه',
  LicenseFrontImage: 'تصویر روی گواهی‌نامه',
  LicenseBackImage: 'تصویر پشت گواهی‌نامه',
  LicenseNumber: 'شماره گواهی‌نامه',
  LicenseTypeId: 'نوع گواهی‌نامه',
  NationalCardBackImage: 'تصویر پشت کارت ملی',
  NationalCardFrontImage: 'تصویر روی کارت ملی',
  VehicleCardFrontImage: 'تصویر روی کارت شناسایی وسیله نقلیه',
  VehicleCardBackImage: 'تصویر پشت کارت شناسایی وسیله نقلیه',
  VehicleCardIssueTime: 'تاریخ صدور کارت شناسایی وسیله نقلیه',
  VehicleCardExpireTime: 'تاریخ اعتبار کارت شناسایی وسیله نقلیه',
  VehicleCardNumber: 'شماره کارت شناسایی وسیله نقلیه',
  VehicleCard: 'کارت شناسایی وسیله نقلیه',
  Neutral: 'شخص حقیقی',
  NationalId: 'کد ملی',
  Male: 'مذکر',
  Female: 'مؤنث',
  Roles: 'نقش ها',
  RealUser: 'کاربر عادی',
  Gender: 'جنسیت',
  Block: 'بلاک',
  Person: 'شخص',
  Password: 'رمز عبور',
  passwordConfirm: 'تایید رمز عبور',
  Profile: 'پروفایل',
  RegistrationNumber: 'شماره ثبت',
  TesterUser: 'کاربر تستی',
  TrajectoryDateMin: 'تاریخچه از',
  TrajectoryDateMax: 'تاریخچه تا',
  Users: 'کاربران',
  Unblock: 'رفع بلاک',
  AreYouSureYouWantToUnblockThisUser:
    'آیا مطمئن هستید که میخواهید این کاربر را رفع بلاک کنید؟',
  userUnblockedSuccessfully: 'کاربر با موفقیت رفع بلاک شد',
  Blocked: 'مسدود شده',
  LimitedUsers: 'کاربران محدود شده',
  legalUser: 'کاربر حقوقی',
  passwordChangedSuccessfully: 'رمز عبور با موفقیت تغییر کرد',
  birthCertificateId: 'شماره شناسنامه',
  marriageDate: 'تاریخ ازدواج',
  documents: 'مدارک',
  licence: 'گواهی نامه',
  smartCard: 'کارت هوشمند',
  smartCardNumber: 'شماره کارت هوشمند',
  smartCardIssueTime: 'تاریخ صدور کارت هوشمند',
  smartCardExpireTime: 'تاریخ اعتبار کارت هوشمند',
  smartCardImageFront: 'عکس کارت هوشمند - جلو',
  smartCardImageBack: 'عکس کارت هوشمند - پشت',
  healthCard: 'کارت سلامت',
  healthCardNumber: 'شماره کارت سلامت',
  healthCardIssueTime: 'تاریخ صدور کارت سلامت',
  healthCardExpireTime: 'تاریخ اعتبار کارت سلامت',
  healthCardImageFront: 'عکس کارت سلامت - جلو',
  healthCardImageBack: 'عکس کارت سلامت - پشت',
  toAdd_FillingAllInformationOfThisSectionIsNecessary:
    'برای اضافه کردن {section}، وارد کردن همه اطلاعات این بخش الزامی است',
  issueDateOf_section_CanNotBeLaterThanExpirationDate:
    'تاریخ صدور {section} نمی تواند بعد از تاریخ اعتبار باشد',
  issueDateOf_section_CanNotBeSameAsExpirationDate:
    'تاریخ صدور {section} نمی تواند یکسان با تاریخ اعتبار باشد',
  sessions: 'نشست ها',
  nationalId: 'کد ملی',
  gender: 'جنسیت',
  fatherName: 'نام پدر',
  bankCard: 'شماره کارت',
  person: 'شخص',
  companyName: 'نام سازمان',
  registrationNumber: 'شماره ثبت',
  economicCode: 'کد اقتصادی',
  legalNationalId: 'شناسه ملی',
  testerUser: 'کاربر تستی',
  licenseNumber: 'شماره گواهی نامه',
  licenseTypeId: 'نوع گواهی نامه',
  licenseExpireTime: 'تاریخ اعتبار گواهی‌نامه',
  licenseFrontImage: 'عکس گواهی نامه - جلو',
  licenseBackImage: 'عکس گواهی نامه - پشت',
  roles: 'نقش ها',
  courierLimit: 'محدودیت بابری',
  changeRoles: 'تغییر نقش ها',
  changeLicense: 'تغییر مجوزهای سطوح دسترسی',
  changeAuthorityLimit: 'تغییر حدود اختیارات',
  userDetail: 'جزئیات کاربر',
  userInformation: 'اطلاعات کاربر',
  userEdit: 'ویرایش کاربر',
  addressId: 'شناسه‌ آدرس',
  userId: 'شناسه کاربر',
  educationLevelId: 'شناسه سطح تحصیلات',
  licenseTypeId: ' نوع گواهینامه',
  contractCategoryId: 'شناسه دسته قرارداد',
  changeLimitLicense: 'تغییر مجوز حدود اختیارات',
  unblock: 'رفع بلاک',
  changePassword: 'تغیر رمز عبور',
  legal: 'شخص حقوقی',
  birthYear: 'سال تولد',
  birthMonth: 'ماه تولد',
  birthDay: 'روز تولد',
  scopeOfAccess: 'حوزه دسترسی',
  userType: 'نوع کاربر',
  mobileConfirmed: 'تایید موبایل',
  emailConfirmed: 'تایید ایمیل',
  blocked: 'مسدود شده',
  companyUser: 'کاربر باربری',
  barbanetUser: 'کاربر بابانت',
  availableCompanies: 'باربری های محدود شده',
  neutral: 'شخص حقیقی',
  deleted: 'حذف شده',
  hasPassword: 'دارای پسورد',
  updateGeneralLimits: 'ویرایش حدود اختیارات عمومی',
  confirmedMobile: 'موبایل تائید شده',
  AreYouSureYouWantToConfirmThisMobile: 'آیا از تایید این شماره اطمینان دارید؟',
  mobileConfirm: 'تائید موبایل',
  mobileConfirmSuccessfully: 'تائید موبایل با موفقیت انجام شد',
  accounting: 'حساب کاربری',
  firstName: 'نام',
  lastName: 'نام خانوادگی',
  completeInformation: 'تکمیل اطلاعات',
  completeInformationWasSuccessfully: 'تکمیل اطلاعات با موفقیت انجام شد',
  AreYouSureYouWantToEnableTester: 'آیا از فعال کردن کاربر تستی اطمینان دارید؟',
  AreYouSureYouWantToDisableTester:
    'آیا از غیر فعال کردن کاربر تستی اطمینان دارید؟',
  changeTester: 'تغییر وضعیت کاربر تستی',
  userHasBeenDisabledTesterSuccessfully:
    'غیر فعال کردن کاربر تستی با موفقیت انجام شد',
  userHasBeenEnabledTesterSuccessfully:
    'فعال کردن کاربر تستی با موفقیت انجام شد',
  changeTwoFactor: 'تغییر وضعیت ورود دو مرحله ای',
  userHasBeenDisabledTwoFactorSuccessfully:
    'غیر فعال کردن ورود دو مرحله ای با موفقیت انجام شد',
  userHasBeenEnabledTwoFactorSuccessfully:
    'فعال کردن ورود دو مرحله ای با موفقیت انجام شد',
  AreYouSureYouWantToEnableTwoFactor:
    'آیا از فعال کردن ورود دو مرحله ای اطمینان دارید؟',
  AreYouSureYouWantToDisableTwoFactor:
    'آیا از غیر فعال کردن ورود دو مرحله ای اطمینان دارید؟',
  twoFactorEnabled: 'ورود دو مرحله ای',
  personalDriver: 'راننده شخصی',
  vehicleMustBeSelected: 'انتخاب خودرو الزامی میباشد',
  suspend: 'تعلیق',
  unsuspend: 'عدم تعلیق',
  AreYouSureYouWantToSuspendThisUser: 'آیا از تعلیق این کاربر مطمئن هستید؟',
  AreYouSureYouWantToDeleteThisDriver: 'آیا از حذف این راننده مطمئن هستید؟',
  AreYouSureYouWantToUnsuspendThisUser:
    'آیا از عدم تعلیق این کاربر مطمئن هستید؟',
  userUnsuspendSuccessfully: 'عدم تعلیق کاربر با موفقیت انجام شد',
  suspendReason: 'دلیل تعلیق کاربر',
  suspendReasonDescription: 'توضیحات تعلیق کاربر',
  acceptShipment: 'قبول سفارش',
  acceptOfferSuccessfully: 'پیشنهاد با موفقیت قبول شد',
  shipmentOffers: 'پیشنهادات سفارش',
  driverCurrentLocation: 'موقعیت راننده',
  addPassword: 'افزودن رمز عبور',
  deleteReason: 'دلیل حذف کاربر',
  deleteReasonDescription: 'توضیحات حذف کاربر',
  driverApproved: 'راننده تایید شد',
  changeLegal: 'ثبت اطلاعات حقوقی',
  updateLegal: 'ویرایش اطلاعات حقوقی',
  legalPhone: 'تلفن',
  legalCityId: 'شناسه شهر',
  userRejectedSuccessfully: 'کاربر رد شد',
  userApprovedSuccessfully: 'کاربر تایید شد',
  oldPassword: 'رمز عبور فعلی',
  newPassword: 'رمز عبور جدید'
}
